<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.mobile" eager :value="visible" width="100%" max-width="720px" persistent @keydown.esc="close">
    <v-card>

      <v-card-title v-text="dialogTitle"></v-card-title>

      <v-card-text>
        <GoogleMaps id="inspection-map" ref="map" :home="home" :address="address" :markers="markers" :zoom="zoom" @directions="showDirections"/>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <span v-if="directions.distance || directions.duration">Sträcka: {{directions.distance && directions.distance.text}} Körtid: {{directions.duration && directions.duration.text}}</span>
        <v-spacer></v-spacer>

        <crm-close-button @click="close"></crm-close-button>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import GoogleMaps from './GoogleMaps'

export default {
  name: 'MapDialog',
  components: { GoogleMaps },
  props: {
    visible: {
      type: Boolean
    },
    home: {
      type: String
    },
    address: {
      type: String
    },
    position: {
      type: Object,
    },
    title: {
      type: String
    }
  },
  data: () => ({
    directions: {}
  }),
  computed: {
    dialogTitle () {
      if (this.title) {
        return this.title
      } else if(this.address) {
        return this.address
      } else if(this.position && this.position.title) {
        return this.position.title
      } else if(this.position) {
        const latitude = new Intl.NumberFormat().format(this.position.latitude || 0)
        const longitude = new Intl.NumberFormat().format(this.position.longitude || 0)
        return `${latitude} ${longitude}`
      } else {
        return null
      }
    },
    zoom () {
      return this.address ? 12 : 15
    },
    markers () {
      return this.position ? [this.position] : []
    }
  },
  methods: {
    showing () {
      this.$nextTick(this.$refs.map.refresh)
    },
    showDirections (dir) {
      this.directions = dir
    },
    close () {
      this.directions = {}
      this.$emit('close')
    }
  },
  watch: {
    visible (state) {
      if (state) {
        this.showing()
      }
    }
  }
}
</script>
